(function () {
  'use strict';

  /* Mouse drag-to-scroll for the scrollable collection list. Touch uses native
     scrolling; the shared helper in eb-drag-scroll.js adds click-and-drag
     panning for desktop pointers. CSS scroll-snap settles the row after
     release. */
  class EbCollectionScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-eb-cl-track]');
      if (!this.track) return;
      window.EbDragScroll.attach(this.track);
    }
  }

  if (!customElements.get('eb-collection-scroller')) {
    customElements.define('eb-collection-scroller', EbCollectionScroller);
  }
})();
